'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var convertFromUxLangToCss = exports.convertFromUxLangToCss = function convertFromUxLangToCss() {
  var ux = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return ux.toLowerCase().replace('.', '_');
};

var convertFromCssToUxLang = exports.convertFromCssToUxLang = function convertFromCssToUxLang() {
  var css = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return css.toUpperCase().replace('_', '.');
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-style-react/dist/src/Typography/Utils.js
// module id = 143
// module chunks = 0 1